import { render, staticRenderFns } from "./TakeOrderList.vue?vue&type=template&id=8db6f452&scoped=true&"
import script from "./TakeOrderList.vue?vue&type=script&lang=js&"
export * from "./TakeOrderList.vue?vue&type=script&lang=js&"
import style0 from "./TakeOrderList.vue?vue&type=style&index=0&id=8db6f452&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db6f452",
  null
  
)

export default component.exports